import {gsap, ScrollTrigger, DrawSVGPlugin, MotionPathPlugin} from "gsap/all";

gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, MotionPathPlugin);
gsap.config({nullTargetWarn: false});
gsap.defaults({ease: "none"});

class challengesAnimation {
    static init() {
        if (document.getElementById('challenges') === null) return;

        this.mainAnimations();
        ScrollTrigger.addEventListener("refreshInit", () => {
            this.debounce(this.mainAnimations, 300)
        })
    }

    static debounce(func, delay) {
        let timer;
        return (args)=> {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    static mainAnimations() {
        ScrollTrigger.getAll().forEach(ST => {
            if(ST.trigger.classList.contains('anchor-section') || ST.trigger.classList.contains('side-bar')) ST.kill();
        });

        let mm = gsap.matchMedia();

        mm.add("(min-width: 1024px)", () => {
            // Desktop Animations

            const scrollSections = gsap.utils.toArray(".anchor-section");
            const links = gsap.utils.toArray(".side-bar-item");
            let arrHeight = [];

            links.forEach((btn, index) => {
                btn.addEventListener("click", (e) => {
                    if(e.currentTarget.classList.contains("active")) return;
                    gsap.to(window, {duration: 1, scrollTo:{y:`#anchor-section-${index}`, offsetY: 100}});
                });

                const fakeTitle = btn.querySelector(".fake-title");
                const fakeTitleHeight = fakeTitle.offsetHeight + 54;
                btn.setAttribute('data-height', fakeTitleHeight);
                if(index !== 0 ) btn.style.height = fakeTitleHeight + "px"; // 50px is padding
                arrHeight.push(fakeTitleHeight);
            });


            scrollSections.forEach((section, i) => {
                const link = links[i];

                ScrollTrigger.create({
                    trigger: section,
                    start: "top-=190px top",
                    end: "bottom-=300px top",
                    invalidateOnRefresh: true,
                    onEnter: () => {
                        link.style.height = "398px";
                        link.classList.add("active");
                    },
                    onEnterBack: () => {
                        link.style.height = "398px";
                        link.classList.add("active");
                    },
                    onLeave: () => {
                        if(i !== scrollSections.length - 1) {
                            link.style.height = link.getAttribute('data-height') + "px";
                            link.querySelector('.hide-scrollbar').scrollTop = 0;
                            link.classList.remove("active")
                        }
                    },
                    onLeaveBack: () => {
                        if(i !== 0) {
                            link.style.height = link.getAttribute('data-height') + "px";
                            link.querySelector('.hide-scrollbar').scrollTop = 0;
                            link.classList.remove("active")
                        }
                    },
                });
            });

            arrHeight.pop();
            arrHeight.push(398);

            let sum = 0;
            arrHeight.forEach((i)=> sum += parseInt(i));


            ScrollTrigger.create({
                trigger: '#challenges .side-bar',
                start: "top-=125px top",
                end: ()=> `+=${document.querySelector("#challenges .track").offsetHeight - (sum + 20)}`, // 20px is margin between items
                pin: true,
                pinSpacing: false,
            });

        });

        mm.add("(max-width: 1023px)", () => {
            // Mobile Animations
        });
    }
}


export default challengesAnimation;